<script lang="ts">
  import type { Snippet } from "svelte"
  import { autoAllocateGridSpans, bodyRowVariants, cn } from ".."
  import { getTableRootContext } from "./Table.svelte"

  const rootCtx = getTableRootContext()

  type Props = {
    cols?: number
    index?: number
    class?: string
    children?: Snippet
  }

  let {
    cols = undefined,
    index = undefined,
    class: cssClass = "",
    children,
  }: Props = $props()

  let ref: Element = $state()!

  const spans = $derived(
    autoAllocateGridSpans(
      Array.from(ref?.querySelectorAll("[role='cell']") ?? []),
      cols ?? $rootCtx.cols
    )
  )
</script>

<div
  bind:this={ref}
  class={cn(
    bodyRowVariants({
      variant: $rootCtx.variant,
      responsive: $rootCtx.responsive,
    }),
    cssClass
  )}
  role="row"
  aria-rowindex={index}
  style:grid-template-columns={spans.map((span) => `${span}fr`).join(" ")}
>
  {@render children?.()}
</div>
